<template>
  <div>
    <div class="perfect-budget-style">
      <!-- 搜索的列表 -->
      <div class="search-row-header">
        <el-row class="search-row" :gutter="10" style="padding-top: 0">
          <el-col :span="6" v-if="employeeLevel > 50">
            <el-select
              v-model="queryParam.orgCode"
              placeholder="选择BUSE"
              filterable
              style="width: 100%"
              @change="changeBuse"
            >
              <el-option
                v-for="item in buList"
                :key="item.orgId"
                :value="item.orgCode"
                :label="item.orgName.split('|')[0]"
              />
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select
              v-model="queryParam.regionCode"
              placeholder="选择区域"
              multiple
              collapse-tags
              filterable
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="item in orgList"
                :key="item.orgId"
                :value="item.orgCode"
                :label="item.orgName.split('|')[0]"
              />
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select
              v-model="queryParam.typeId"
              placeholder="选择预算池"
              multiple
              collapse-tags
              filterable
              @change="changeBudget"
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="item in budgetList"
                :label="`${item.typeName}（${item.trCode}）`"
                :value="item.typeId"
                :key="item.typeId"
              />
            </el-select>
          </el-col>
          <el-col :span="2" class="buttonCol">
            <el-button class="btn-red" size="medium" @click="handleSearch()"
              >搜索</el-button
            >
          </el-col>
          <el-col :span="2">
            <el-button
              type="info"
              class="btn-reset"
              size="medium"
              @click="handleReset(queryParam)"
              >重置</el-button
            >
          </el-col>
        </el-row>
        <div>
          <el-button
            type="danger"
            class="btn-red"
            size="medium"
            @click="handleBudget()"
            >维护预算池</el-button
          >
        </div>
      </div>
      <!-- 展示数据 -->
      <ul class="show-data-content">
        <li class="show-content-li">
          <p>可用预算:</p>
          <span>{{ listObj.availableAmount | formatNumber("number") }}</span>
        </li>

        <li class="show-content-li">
          <el-tooltip
            class="item"
            effect="dark"
            content="待审批订单占用的预算"
            placement="top-start"
          >
          <i class="el-icon-question"></i>
            <!-- <i class="el-icon-question"></i> -->
          </el-tooltip>
          <!-- <i class="el-icon-question"></i> -->
          <p>冻结预算:</p>
          <span>{{ listObj.freezeAmount | formatNumber("number") }}</span>
        </li>
        <li class="show-content-li">
          <el-tooltip
            class="item"
            effect="dark"
            content="执行中订单占用的预算"
            placement="top-start"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
          <p>已用预算:</p>
          <span>{{ listObj.usedAmount | formatNumber("number") }}</span>
        </li>
        <li class="show-content-li">
          <p>总计预算:</p>
          <span>{{ listObj.totalAmount | formatNumber("number") }}</span>
        </li>
      </ul>
      <!-- table数据 -->
      <div v-if="filterHeadConfig.length > 0" class="tableListStyle">
        <el-table
          :data="clientInfoList"
          max-height="500"
          v-loading="listLoading"
          :key="tableHeadConfig.length"
          row-key="regionCode"
          default-expand-all
          :header-cell-style="{
            background: '#ffdade',
            color: '#606266',
            textAlign: 'center',
            fontSize: '14px',
          }"
          :tree-props="{
            children: 'areaBudgetInfos',
            hasChildren: 'hasChildren',
          }"
          :cell-style="cellStyle"
        >
          <el-table-column
            label="Region/Area"
            min-width="148"
            prop="regionName"
            align="left"
            class-name="region-area-value"
            fixed="left"
          />
          <el-table-column
            v-for="(head, index) in filterHeadConfig"
            :key="index"
            :label="head.typeName"
            :prop="head.typeName"
            align="center"
          >
          <template slot="header">
            <div>{{ `${head.typeName} ` }}</div>
            <div style="color:#C8102D;font-weight:400;font-size:12px">{{`( ${head.trCodeName} )`}}</div>
          </template>
            <el-table-column
              label="可用"
              align="center"
              min-width="99"
              class-name="fontSize"
              label-class-name="totalFontClass"
              show-overflow-tooltip
            >
              <template slot-scope="{ row }">
                {{
                  row[head.typeName + "-" + "available"]
                    | formatNumber("number")
                }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              min-width="99"
              class-name="fontSize"
              label-class-name="totalFontClass"
            >
              <template #header>
                <span>冻结</span>
                <el-tooltip
                  effect="dark"
                  content="待审批订单占用的预算"
                  placement="top-start"
                >
                  <span class="qustionStyle"><i class="el-icon-question"></i></span>
                </el-tooltip>
              </template>
              <template slot-scope="{ row }">
                {{
                  row[head.typeName + "-" + "freeze"] | formatNumber("number")
                }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              min-width="99"
              class-name="fontSize"
              label-class-name="totalFontClass"
            >
              <template #header>
                <span>已用</span>
                <el-tooltip
                  effect="dark"
                  content="执行中订单占用的预算"
                  placement="top-start"
                >
                  <span><i class="el-icon-question"></i></span>
                </el-tooltip>
              </template>
              <template slot-scope="{ row }">
                {{ row[head.typeName + "-" + "used"] | formatNumber("number") }}
              </template>
            </el-table-column>
            <el-table-column
              label="总计"
              align="center"
              min-width="99"
              class-name="totalColor"
              label-class-name="totalClass"
            >
              <template slot-scope="{ row }">
                {{
                  row[head.typeName + "-" + "total"] | formatNumber("number")
                }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="合计"
            align="center"
            fixed="right"
            width="399"
            class-name="colColor"
          >
            <el-table-column
              align="center"
              label="可用"
              fixed="right"
              label-class-name="totalFontClass"
              prop="availableAmount"
              class-name="availableStyle"
              width="100"
            >
              <template slot-scope="{ row }">
                {{ row.availableAmount | formatNumber("number") }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="冻结"
              fixed="right"
              label-class-name="totalFontClass"
              class-name="fontSize"
              prop="freezeAmount"
              width="100"
            >
              <template #header>
                <span>冻结</span>
                <el-tooltip
                  effect="dark"
                  content="待审批订单占用的预算"
                  placement="top-start"
                >
                  <span><i class="el-icon-question"></i></span>
                </el-tooltip>
              </template>
              <template slot-scope="{ row }">
                {{ row.freezeAmount | formatNumber("number") }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="已用"
              fixed="right"
              class-name="fontSize"
              prop="usedAmount"
              width="100"
            >
              <template #header>
                <span>已用</span>
                <el-tooltip
                  effect="dark"
                  content="执行中订单占用的预算"
                  placement="top-start"
                >
                  <span><i class="el-icon-question"></i></span>
                </el-tooltip>
              </template>
              <template slot-scope="{ row }">
                {{ row.usedAmount | formatNumber("number") }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="总计"
              fixed="right"
              class-name="totalColor"
              label-class-name="totalClass"
              prop="totalAmount"
              width="100"
            >
              <template slot-scope="{ row }">
                {{ row.totalAmount | formatNumber("number") }}
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
        <!-- 编辑按钮 -->
        <div class="btn">
          <el-button
            type="danger"
            class="btn-red"
            size="medium"
            @click="editorBudget()"
            >编辑预算</el-button
          >
        </div>
      </div>
      <div class="no-data" v-else>当前暂无预算数据，请先维护预算池！</div>
    </div>
    <MaintBudget ref="maintenance-budget-pool" @refresh="refresh" />
  </div>
</template>

<script>
import MaintBudget from './components/maintenance-budget-pool'
import { mapGetters } from 'vuex'
import budgetApi from '@/api/budget'

// import _ from 'lodash'
// 千分符
const filters = {
  formatNumber (number, type) {
    if (!number && number !== 0) return
    if (type === 'number') {
      return number.toLocaleString()
    } else if (type === 'money') {
      return '￥' + number.toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
    }
  }
}
export default {
  name: 'perfect-budget',
  components: {
    MaintBudget

  },
  data () {
    return {
      val: '',
      listLoading: false,
      page: 1,
      buList: [], // buse
      orgList: [], // 区域
      budgetList: [], // 预算
      // 搜索条件
      queryParam: {
        orgCode: '',
        regionCode: [],
        typeId: []
      },
      buListPool: {},
      // 展示数据
      listObj: {},
      // table标题-预算池
      tableHeadConfig: [],
      // 当BUSE账号|regin账号---table数据
      clientInfoList: [],
      // 预算池
      budgetPoolDetailList: [
        {
          itemName: '',
          note: ''

        }
      ],
      employeeLevel: null,
      openCode: ''
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    filterHeadConfig () {
      let headList = []
      if (this.queryParam.typeId.length) {
        // headList = this.tableHeadConfig.filter(head => head.typeId === this.queryParam.typeId)
        headList = this.tableHeadConfig.filter(head => {
          const isHas = this.queryParam.typeId.includes(head.typeId)
          if (isHas) {
            return true
          }
        })
      } else {
        headList = this.tableHeadConfig
      }
      return headList
    }
  },
  filters,
  created () {
    if (this.$route.query.buCode) {
      this.openCode = this.$route.query.buCode
    }
    this.employeeLevel = this.userInfo.employeeLevel
    this.getAllRegionList()
  },
  mounted () { },
  methods: {
    cellStyle (val) {
      if (val.columnIndex === 0 && val.row.budgetLevel !== 0) {
        return 'background: rgb(246,247,251);border-bottom: 1px solid rgb(246, 247, 251);'
      }
      if (val.row.budgetLevel === 0) {
        return 'background: #feffec; font-size: 12px;'
      }
      if (val.column.fixed === 'right') {
        return 'background: rgb(246,247,251);border-bottom: 1px solid rgb(246, 247, 251);font-size: 12px;'
      }
      if (val.column.label === '可用' || val.column.label === '冻结' || val.column.label === '已用') {
        return 'font-size: 12px;'
      }
    },
    refresh (val) {
      this.val = val
      this.queryParam.orgCode = val // 预算池返回  接受code值
      this.getAllRegionList()
      // this.handleSearch()
    },
    // 获取BUSE
    getAllRegionList () {
      budgetApi.getAllRegionList().then(res => {
        if (res.data.resultCode === '0') {
          // this.queryParam.orgCode = res.data.resultData.orgList[0].orgCode // 默认选中第一
          if (this.openCode) {
            this.queryParam.orgCode = this.openCode
          } else {
            this.queryParam.orgCode = res.data.resultData.orgList[0].orgCode // 默认选中第一
          }
          this.buList = res.data.resultData.orgList // 赋值给数据buList渲染
          this.getOrgList(this.queryParam.orgCode)
          this.getBudget(this.queryParam.orgCode)
          this.handleSearch() // table数据
        }
      })
    },
    // 选择buse option
    changeBuse (code) {
      // 切换第一个input 清空关联的input
      this.queryParam.regionCode = []
      this.queryParam.typeId = []
      this.queryParam.orgCode = code
      this.openCode = code
      this.handleSearch()
      this.getOrgList(this.queryParam.orgCode)
      this.getBudget(this.queryParam.orgCode)
    },
    changeBudget (code) {
      this.handleSearch()
    },
    // 获取区域
    getOrgList (buCode) {
      let params = {
        buCode: buCode
      }
      budgetApi.getOrgList(params).then(res => {
        if (res.data.resultCode === '0') {
          this.orgList = res.data.resultData.orgList
        }
      })
    },
    // 获取预算池名称
    getBudget (buCode) {
      let params = {
        buCode: buCode
      }
      budgetApi.getTableHeadConfig(params).then(res => {
        if (res.data.resultCode === '0') {
          this.budgetList = res.data.resultData.budgetTypeList// 下拉框
          this.tableHeadConfig = res.data.resultData.budgetTypeList// 表头
        }
      })
    },
    // 搜索|获取-table数据
    handleSearch () {
      if (!this.queryParam.orgCode) {
        this.$message.error('请先选择BUSE')
        return
      }
      this.loading = true
      let params = {
        buCode: this.queryParam.orgCode,
        typeIds: this.queryParam.typeId,
        // typeId: [],
        regionCodes: this.queryParam.regionCode
      }
      budgetApi.getPerfectThemeList(params).then(res => {
        if (res.data.resultCode === '0') {
          let resData = res.data.resultData.budgetInfoList
          this.clientInfoList = this.deepCLone(resData)
          this.listObj = this.clientInfoList[0]
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 处理数据
    deepCLone (arr) {
      let tempArr = []
      arr.forEach(parent => {
        let tempObj = {
          regionCode: parent.regionCode,
          regionName: parent.regionName.split('|')[0],
          budgetLevel: parent.budgetLevel,
          budgetInfos: parent.budgetInfos,
          areaBudgetInfos: parent.areaBudgetInfos || [],
          availableAmount: parent.availableAmount,
          freezeAmount: parent.freezeAmount,
          usedAmount: parent.usedAmount,
          totalAmount: parent.totalAmount
        }
        tempObj.budgetInfos.forEach(item => {
          const mapObj = {
            typeName: item.typeName,
            available: item.availableAmount,
            freeze: item.freezeAmount,
            used: item.usedAmount,
            total: item.totalAmount
          }
          tempObj[item.typeName + '-available'] = mapObj.available
          tempObj[item.typeName + '-freeze'] = mapObj.freeze
          tempObj[item.typeName + '-used'] = mapObj.used
          tempObj[item.typeName + '-total'] = mapObj.total
        })
        if (tempObj.budgetLevel === 10) {
          tempObj.areaBudgetInfos = this.deepCLone(parent.areaBudgetInfos)
        }
        tempArr.push(tempObj)
      })
      return tempArr
    },
    // 重置
    handleReset () {
      // this.queryParam = this.$options.data().queryParam
      // if (this.$route.query.buCode) {
      //   this.queryParam.orgCode = this.$route.query.buCode
      // }
      this.queryParam.regionCode = []
      this.queryParam.typeId = []
      this.getAllRegionList()
    },
    // 维护预算
    handleBudget () {
      this.$refs['maintenance-budget-pool'].show()
      this.$refs['maintenance-budget-pool'].editorBudget(this.queryParam)
    },
    // 编辑预算
    editorBudget () {
      this.$router.push({ path: '/trade/editor-budget', query: { buCode: this.queryParam.orgCode } })
    }
  }
}
</script>

<style lang="scss" scoped>
.perfect-budget-style {
  // background: pink;
  width: 1200px;
  margin: 0 auto;
  ::v-deep .el-table__expand-icon {
    display: none !important;
  }
  ::v-deep .el-input__inner {
    text-align: left !important;
  }
  .no-data {
    text-align: center;
  }
  .btn {
    margin: 25px;
    text-align: center;
  }
  .search-row-header {
    display: flex;
    justify-content: space-between;
  }
  li,
  ul {
    list-style: none;
  }
  ::v-deep .el-col-3 {
    text-align: center;
  }
  .show-data-content {
    display: flex;
    justify-content: space-between;
    width: 600px;
    padding: 0px;
    .show-content-li {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: 5px;
      p {
        margin-right: 5px;
      }
      span {
        flex: 1;
        color: #c8102d;
      }
    }
  }

  // .el-table__row {
  //   .el-table_1_column_2_column_3{
  //     .cell{
  //        visibility: visible
  //     }
  // }
  // }
}
::v-deep .el-table__fixed-right-patch {
  background: rgb(255, 218, 222);
}
::v-deep .totalClass {
  color: #ca0c28;
}
::v-deep .fontSize {
  font-size: 12px !important;
}
::v-deep .totalColor {
  color: #ca0c28;
  font-size: 12px;
}
::v-deep .region-area-value {
  font-size: 14px !important;
}
::v-deep .availableStyle {
  background: red($color: #000000);
  font-size: 12px;
}
::v-deep .totalFontClass {
  font-size: 14px;
}
.buttonCol {
  margin-right: 9px;
}
// ::v-deep .colColor{
//   background: #c8102d;
// }
// .el-table__row > td {
//   border: none;
// }
// .el-table::before {
//   //去掉最下面的那一条线
//   height: 0px;
// }
// ::v-deep .el-tooltip {
//   font-size: 5px;
// }
//  .qustionStyle i{
//   overflow:hidden;text-overflow:ellipsis;display: inline
// }
</style>
